import jwt from 'jsrsasign';
import Loadable from 'react-loadable';
import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import uuid from 'uuid/v4';

import { zendeskConfig } from '@config';
import { userDataSelector } from '@selectors/global';

import {
  appAuthenticated,
  appBootstrap,
  BOOTSTRAP,
  AUTHENTICATED,
} from './AppActions';

function* appBootstrapSaga() {
  yield put(appBootstrap());
}

function* appAuthenticatedSaga() {
  yield put(appAuthenticated());
}

function* preloadPages() {
  yield Loadable.preloadAll();
}

function* authenticateZendesk() {
  const { key, secret } = zendeskConfig;
  const user = yield select(userDataSelector);

  const payload = {
    name: user.get('name'),
    email: user.get('email'),
    iat: Math.floor(Date.now() / 1000),
    jti: uuid(),
  };

  const token = yield call(
    jwt.jws.JWS.sign,
    'HS256',
    JSON.stringify({ alg: 'HS256', typ: 'JWT' }),
    JSON.stringify(payload),
    { utf8: secret },
  );

  // Set authentication settings before widget loads
  window.zESettings = {
    authenticate: { jwt: token },
    offset: { horizontal: '0px', vertical: '0px' },
    webWidget: {
      position: { horizontal: 'left', vertical: 'bottom' },
    },
  };

  // Load the widget script dynamically after auth is set
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'ze-snippet';
  script.async = true;
  script.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;

  // Add event listener to hide widget after it loads
  script.onload = () => {
    if (window.zE) {
      window.zE('webWidget', 'hide');
    }
  };

  document.head.appendChild(script);
}

function* appSagas() {
  yield all([
    takeLatest('CONFIGURE', appBootstrapSaga),
    takeLatest('LOGIN_SUCCESS', appAuthenticatedSaga),
    takeLatest(BOOTSTRAP, preloadPages),
    takeLatest(AUTHENTICATED, authenticateZendesk),
  ]);
}

export default appSagas;
